import { FaqServiceSupportThemeSizeConfig } from './types';

const small: FaqServiceSupportThemeSizeConfig = {
  faqServiceSupport: {},
};

export default small;
